import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = (theme: Theme) =>
  createStyles({
    fileContainer: {
      borderRadius: 8,
      border: `1px dashed ${colours.neutral[300]}`,
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
      backgroundColor: colours.solid.white,
    },
    fileCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      padding: theme.spacing(1.5, 2),
      backgroundColor: colours.neutral[50],
      borderRadius: 8,
    },
    fileLeft: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
    fileIcon: {
      display: 'flex',
      marginRight: theme.spacing(1.5),
    },
    fileName: {
      fontSize: 14,
      fontWeight: 500,
    },
    fileRight: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
    fileSize: {
      fontSize: 14,
      color: colours.neutral[500],
      marginRight: theme.spacing(1),
    },
    placeholder: {
      width: '100%',
      padding: theme.spacing(6, 3),
      gap: theme.spacing(3),
      margin: 'auto',
      borderRadius: 6,
      border: `1px solid ${colours.neutral[200]}`,
      marginBottom: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colours.solid.white,
    },
    smallHeading: {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '24px',
      color: colours.neutral[900],
      margin: 0,
    },
    smallSubHeading: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      color: colours.neutral[500],
      margin: 0,
    },
  });
